import { actionTypes } from "./actions";
import { exampleInitialState } from "./store";

function reducer(state = exampleInitialState, action) {
  switch (action.type) {
    case actionTypes.SET_HEADER_VISIBLE:
      return {
        ...state,
        headerHide: action.payload,
      };
    case actionTypes.SET_CUSTOMER_NAME:
      return {
        ...state,
        customerName: action.payload,
      };
    case actionTypes.SET_LOADING_PAGE:
      return {
        ...state,
        loading: action.payload,
      };
    case actionTypes.SET_ERROR_MESSAGE:
      return {
        ...state,
        errorMessage: action.payload,
      };
    case actionTypes.SET_TIMEZONE_ID:
      return {
        ...state,
        timeZoneId: action.payload,
      };
    case actionTypes.SET_REAL_TIME_GROUP:
      return {
        ...state,
        realTimeGroup: action.payload,
      };
    case actionTypes.SET_REAL_TIME_GROUP_ID:
      return {
        ...state,
        realTimeGroupId: action.payload,
      };
    case actionTypes.SET_REAL_TIME_GROUP_NAME:
      return {
        ...state,
        realTimeGroupName: action.payload,
      };
    case actionTypes.SET_REPORT_ASSET_ID:
        return {
          ...state,
          reportAssetId: action.payload,
        };
   case actionTypes.SET_REPORT_CALENDAR_DATE:
          return {
            ...state,
            reportDate: action.payload,
          };  
   case actionTypes.SET_REPORT_ASSET_NAME:
          return {
            ...state,
            reportAssetName: action.payload,
          };
   case actionTypes.SET_REPORT_GROUP_ID:
          return {
            ...state,
            reportGroupId: action.payload,
          };
    default:
      return state;
  }
}

export default reducer;
